// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"cceac842","164":"7cb845c7","991":"f8e2f248"}[chunkId] + ".chunk.css";
};